import { useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { lightTheme, getTheme } from "./theme";
import ApplicationRoutes from "./routes/ApplicationRoutes";
import Login from "./pages/login/Login";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "./app/features/store/store";
import { refreshToken } from "./app/features/login/loginSlice";
import { toast } from "react-toastify";
import getAxiosError from "./app/api/axiosError";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import HealthCheck from "./app/api/healthCheck/HealthCheck";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import ResetPassword from "./pages/resetPassword/ResetPassword";

function App() {
  const dispatch = useAppDispatch();

  let themeName = "default";
  let themeSelector = themeName ? getTheme(themeName!) : lightTheme;
  const isValidToken = useSelector(
    (state: RootState) => state.login?.authResponse?.tokenDetails?.isValidToken
  );

  //Broweser refresh or Autorefresh token
  useEffect(() => {
    let isTokenRefreshFunctionRan = true;
    const tokenRefresh = async () => {
      try {
        localStorage.removeItem("isLoggedIn");
        const response = await dispatch(refreshToken()).unwrap();
        if (response.isSuccess) {
          localStorage.setItem("isLoggedIn", "true");
        } else {
          toast.error(response.message!);
        }
      } catch (error) {
        const appError = getAxiosError(error);
        toast.error(appError.errorMessage, { toastId: "appSessionExpired" });
      }
    };

    let refreshRan = false;

    //Browser Refresh
    if (isTokenRefreshFunctionRan) {
      if (
        localStorage.getItem("isLoggedIn") === "true" &&
        (isValidToken === undefined || !isValidToken) &&
        !refreshRan
      ) {
        tokenRefresh();
        refreshRan = !refreshRan;
      }
    }

    return () => {
      isTokenRefreshFunctionRan = false;
    };
  }, [dispatch, isValidToken]);

  return (
    <>
      <ThemeProvider theme={themeSelector}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <div className="app">
            <main className="content">
              {isValidToken || localStorage.getItem("isLoggedIn") === "true" ? (
                <ApplicationRoutes />
              ) : window.window.location.pathname === "/health" ? (
                <HealthCheck />
              ) : window.window.location.pathname === "/forgot-password" ? (
                <ForgotPassword />
              ) : window.window.location.pathname === "/password-request" ? (
                <ResetPassword byLinkResetPassword={true} />
              ) : (
                <Login />
              )}
            </main>
          </div>
        </LocalizationProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
